<template>
    <content-loader
        :width="375"
        :height="688"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
        <rect x="15" y="1" rx="0" ry="0" width="345" height="33" />
        <rect x="16" y="50" rx="0" ry="0" width="345" height="80" />
        <rect x="15" y="140" rx="0" ry="0" width="345" height="60" />
        <rect x="16" y="210" rx="0" ry="0" width="345" height="50" />
        <rect x="16" y="270" rx="0" ry="0" width="345" height="80" />
        <rect x="16" y="360" rx="0" ry="0" width="345" height="120" />
        <rect x="15" y="490" rx="0" ry="0" width="168" height="90" />
        <rect x="195" y="490" rx="0" ry="0" width="168" height="90" />
        <rect x="15" y="590" rx="0" ry="0" width="168" height="90" />
       <rect x="195" y="590" rx="0" ry="0" width="168" height="90" />
       <rect x="16" y="690" rx="0" ry="0" width="345" height="120" />
    </content-loader>
</template>

<script>
    import { ContentLoader } from "vue-content-loader"

    export default {
        components: { ContentLoader }
    }
</script>



// WEBPACK FOOTER //
// src/skeleton/subjectSkeleton.vue